import React, { FC } from 'react';
import { Paper, Box } from '@mui/material';
import { OrderEvent, OrderEventType } from 'models/order-event';
import EventRecordTitle from 'components/shared/order-events-timeline/order-events/event-record-title.component';
import { eventAuthor } from 'components/shared/order-events-timeline/event-organization';
import { useTranslation } from 'react-i18next';

type EventOrderStatusProps = {
    item: OrderEvent;
    displayOrderLabel?: boolean;
};
const EventOrderStatus: FC<EventOrderStatusProps> = ({ item, displayOrderLabel }: EventOrderStatusProps) => {
    const { t: translate } = useTranslation(['order-event']);

    const changedBy = () => eventAuthor(item, translate('API_INTEGRATION'));

    const createTitle = () => {
        switch (item.type) {
            case OrderEventType.ORDER_MODIFIED:
                return `${translate('ORDER_CHANGED_BY')} ${changedBy()}`;
            case OrderEventType.ORDER_RESEND:
                return `${translate('RESENT_BY')} ${changedBy()}`;
            case OrderEventType.STATUS_CHANGE:
                return `${translate('STATUS_CHANGED_BY')} ${changedBy()}`;
            default:
                return '';
        }
    };

    const shouldDisplayMessage = () => {
        return item.type !== OrderEventType.ORDER_RESEND && item.message && item.message !== 'OTHER';
    };

    return (
        <Paper variant="outlined">
            <Box p={2}>
                <EventRecordTitle
                    title={createTitle()}
                    item={item}
                    color={item.color}
                    displayOrderLabel={displayOrderLabel}
                />
                {shouldDisplayMessage() ? <Box mt={1}>{translate(`${item.message}`)}.</Box> : undefined}
            </Box>
        </Paper>
    );
};

export default EventOrderStatus;
